import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ArcGISFeatureServiceItemData } from '../models/arcgis-types';
import { buildArcGISRequestUrl } from '../utils/arcgis-url.util';

@Injectable({
    providedIn: 'root'
})
export class ArcGISItemStyleService {
    private readonly http: HttpClient;
    private readonly requests = new Map<string, Promise<ArcGISFeatureServiceItemData | null>>();

    constructor(backend: HttpBackend) {
        this.http = new HttpClient(backend);
    }

    public clearRequests(): void {
        this.requests.clear();
    }

    public getItemData(portalUrl: string | null, itemId: string | undefined, token: string | null = null): Promise<ArcGISFeatureServiceItemData | null> {
        if (!portalUrl || !itemId || !/^[a-f0-9]{32}$/i.test(itemId)) {
            return Promise.resolve(null);
        }

        const url = buildArcGISRequestUrl(portalUrl, `sharing/rest/content/items/${itemId}/data`, { f: 'json', token });
        const existing = this.requests.get(url);
        if (existing) {
            return existing;
        }

        const request = firstValueFrom(this.http.get<ArcGISFeatureServiceItemData>(
            buildArcGISRequestUrl(url, '', { _ts: Date.now() })
        ))
            .then(data => Array.isArray(data?.layers) ? data : null)
            .catch(() => null)
            .finally(() => {
                if (this.requests.get(url) === request) {
                    this.requests.delete(url);
                }
            });
        this.requests.set(url, request);
        return request;
    }
}
